import course1 from "../../../public/courses/Programing Basics.jpg";
import course2 from "../../../public/courses/C-sharp Fundamentals.jpg";
import course3 from "../../../public/courses/C-sharp Advanced.jpg";
import course4 from "../../../public/courses/MS SQL.jpg";
import course5 from "../../../public/courses/C-sharp OOP.jpg";
import course6 from "../../../public/courses/C-sharp WebBasics.jpg";
import course7 from "../../../public/courses/ASP.NET Core.jpg";
import course8 from "../../../public/courses/JS Advanced.jpg";
import course9 from "../../../public/courses/JS Applications.jpg";
import course10 from "../../../public/courses/EFCore.jpg";
import course11 from "../../../public/courses/HTML&CSS.jpg";
import course12 from "../../../public/courses/Udemy complete web development.jpg";
import course13 from "../../../public/courses/Cyber Security-SOC and SIEM (SPLUNK&ELK) for Beginners Cert.jpg";
import course14 from "../../../public/courses/React cert.jpg";
import course15 from "../../../public/courses/THM pre security cert.png";
import course16 from "../../../public/courses/THM-intro to Cyber Security cert.png";

const carouselData = [
    
    {
        image: course13, alt: 'Cyber Security-SOC and SIEM for beginners', date: '26-03-2024'
    },
    {
        image: course15, alt: 'THM pre security', date: '9-03-2024'
    },
    {
        image: course16, alt: 'THM-intro to Cyber Security', date: '4-03-2024'
    },
    {
        image: course14, alt: 'React', date: '18-03-2024'
    },
    {
        image: course12, alt: 'udemy web development', date: '28-12-2023'
    },
    {
        image: course11, alt: 'HTML&CSS', date: '12-01-2022'
    },
    {
        image: course9, alt: 'JS Applications', date: '21-10-2021'
    },
    {
        image: course8, alt: 'JS Advanced', date: '5-09-2021'
    },
    {
        image: course10, alt: 'EFCore', date: '5-10-2021'
    },
    {
        image: course7, alt: 'ASP.NET Core', date: '6-06-2021'
    },
    {
        image: course6, alt: 'C# WebBasics', date: '12-05-2021'
    },
    {
        image: course5, alt: 'C# OOP', date: '15-02-2021'
    },
    {
        image: course4, alt: 'MS SQL', date: '13-01-2021'
    },
    {
        image: course3, alt: 'C# Advanced', date: '7-01-2021'
    },
    {
        image: course2, alt: 'C# Fundamentals', date: '16-09-2020'
    },
    {
        image: course1 , alt: 'Programing Basics', date: '24-07-2020'
    },
    
    
    
    
    
    
    
    
    
    

]

export default carouselData;